var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "floatl", class: _vm.classes },
    [
      _vm._t("default"),
      !_vm.hideLabel
        ? _c(
            "div",
            {
              staticClass: "floatl__label select-none",
              class: { "floatl__label--textarea": _vm.textarea },
              on: { click: _vm.handleClick }
            },
            [_vm._v(_vm._s(_vm.placeholder))]
          )
        : _vm._e(),
      _c("div", {
        staticClass: "floatl__bg top-0 left-0 w-full h-full absolute"
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }